var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPageWithContent = function SvgPageWithContent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_893_8513",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 42,
    height: 42
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_893_8513)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.2749 31.5002H25.7249C26.1617 31.5002 26.5334 31.3469 26.84 31.0403C27.1466 30.7337 27.2999 30.362 27.2999 29.9252C27.2999 29.4884 27.1466 29.1167 26.84 28.8101C26.5334 28.5035 26.1617 28.3502 25.7249 28.3502H16.2749C15.8381 28.3502 15.4664 28.5035 15.1598 28.8101C14.8532 29.1167 14.6999 29.4884 14.6999 29.9252C14.6999 30.362 14.8532 30.7337 15.1598 31.0403C15.4664 31.3469 15.8381 31.5002 16.2749 31.5002ZM16.2749 25.2002H25.7249C26.1617 25.2002 26.5334 25.0469 26.84 24.7403C27.1466 24.4337 27.2999 24.062 27.2999 23.6252C27.2999 23.1884 27.1466 22.8167 26.84 22.5101C26.5334 22.2035 26.1617 22.0502 25.7249 22.0502H16.2749C15.8381 22.0502 15.4664 22.2035 15.1598 22.5101C14.8532 22.8167 14.6999 23.1884 14.6999 23.6252C14.6999 24.062 14.8532 24.4337 15.1598 24.7403C15.4664 25.0469 15.8381 25.2002 16.2749 25.2002ZM11.5499 37.8002C10.6749 37.8002 9.9315 37.4936 9.3197 36.8804C8.7065 36.2686 8.3999 35.5252 8.3999 34.6502V7.3502C8.3999 6.4752 8.7065 5.7318 9.3197 5.12C9.9315 4.5068 10.6749 4.2002 11.5499 4.2002H23.8874C24.2962 4.2002 24.6903 4.273 25.0697 4.4186C25.4477 4.5642 25.7977 4.798 26.1197 5.12L32.6801 11.6804C33.0021 12.0024 33.2359 12.3531 33.3815 12.7325C33.5271 13.1105 33.5999 13.5039 33.5999 13.9127V34.6502C33.5999 35.5252 33.2933 36.2686 32.6801 36.8804C32.0683 37.4936 31.3249 37.8002 30.4499 37.8002H11.5499ZM23.0999 13.1252V7.3502H11.5499V34.6502H30.4499V14.7002H24.6749C24.2381 14.7002 23.8664 14.5469 23.5598 14.2403C23.2532 13.9337 23.0999 13.562 23.0999 13.1252Z",
    fill: "#65748C"
  }))));
};
export default SvgPageWithContent;